import { render, staticRenderFns } from "./RicUserIndex.vue?vue&type=template&id=0e1f8142"
import script from "./RicUserIndex.vue?vue&type=script&lang=ts"
export * from "./RicUserIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports